/**
 * TEST Veegreen article enhancer
 * Revert: delete this file + remove its script tag from sections/main-article.liquid
 *
 * Transforms common blog markup (intro, numbered H3s, CTA, about) into vg-* blocks.
 */
(function () {
  function isHeading(node) {
    return node && /^H[1-6]$/.test(node.tagName);
  }

  function headingLevel(node) {
    return parseInt(node.tagName.charAt(1), 10);
  }

  function extractNumber(text) {
    var match = String(text || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .match(/^(\d+)\s*[.\)\-–—:]?\s*/);
    return match ? match[1] : null;
  }

  function looksLikeAbout(text) {
    return /a\s*propos|à\s*propos|about\s*us|veegreen\s*est/i.test(text || '');
  }

  function looksLikeCta(el) {
    if (!el || el.tagName !== 'P') return false;
    var text = (el.textContent || '').toLowerCase();
    return (
      el.querySelector('a') &&
      (/envie|découvrez|decouvrez|coffret|je découvre|je decouvre|acheter|commander/.test(text) ||
        (el.querySelectorAll('strong').length >= 1 && text.length < 280))
    );
  }

  function wrapIntro(root) {
    var nodes = [];
    var child = root.firstElementChild;
    while (child && !isHeading(child)) {
      nodes.push(child);
      child = child.nextElementSibling;
    }
    if (nodes.length === 0) return;
    var wrap = document.createElement('div');
    wrap.className = 'vg-intro';
    root.insertBefore(wrap, nodes[0]);
    nodes.forEach(function (node) {
      wrap.appendChild(node);
    });
  }

  function wrapBenefits(root) {
    var headings = Array.prototype.slice.call(root.querySelectorAll('h3'));
    if (headings.length < 2) return;

    var benefitGroups = [];
    headings.forEach(function (h3) {
      if (h3.closest('.vg-benefit, .vg-final-block')) return;
      var nodes = [h3];
      var next = h3.nextElementSibling;
      while (next && !isHeading(next)) {
        nodes.push(next);
        next = next.nextElementSibling;
      }
      benefitGroups.push(nodes);
    });

    if (benefitGroups.length < 2) return;

    var list = document.createElement('div');
    list.className = 'vg-benefits';
    root.insertBefore(list, benefitGroups[0][0]);

    benefitGroups.forEach(function (nodes, index) {
      var card = document.createElement('section');
      card.className = 'vg-benefit';

      var h3 = nodes[0];
      var number = extractNumber(h3.textContent) || String(index + 1);
      var cleaned = (h3.textContent || '')
        .replace(/\u00a0/g, ' ')
        .replace(/^\s*\d+\s*[.\)\-–—:]?\s*/, '')
        .trim();
      if (cleaned) h3.textContent = cleaned;

      var badge = document.createElement('span');
      badge.className = 'vg-benefit-number';
      badge.textContent = number;
      badge.setAttribute('aria-hidden', 'true');

      var body = document.createElement('div');
      list.appendChild(card);
      card.appendChild(badge);
      card.appendChild(body);
      nodes.forEach(function (node) {
        body.appendChild(node);
      });
    });
  }

  function wrapCtaAndAbout(root) {
    Array.prototype.slice.call(root.children).forEach(function (el) {
      if (looksLikeCta(el) && !el.closest('.vg-cta, .vg-final-block, .vg-benefit')) {
        var cta = document.createElement('div');
        cta.className = 'vg-cta';
        root.insertBefore(cta, el);
        cta.appendChild(el);
        var follow = cta.nextElementSibling;
        if (follow && follow.tagName === 'P' && looksLikeCta(follow)) {
          cta.appendChild(follow);
        }
      }
    });

    Array.prototype.slice.call(root.querySelectorAll('h2')).forEach(function (h2) {
      if (!looksLikeAbout(h2.textContent)) return;
      if (h2.closest('.vg-final-block')) return;

      var nodes = [h2];
      var next = h2.nextElementSibling;
      while (next && !(isHeading(next) && headingLevel(next) <= 2)) {
        nodes.push(next);
        next = next.nextElementSibling;
      }

      var block = document.createElement('section');
      block.className = 'vg-final-block';
      root.insertBefore(block, nodes[0]);
      nodes.forEach(function (node) {
        block.appendChild(node);
      });
    });
  }

  function wrapImages(root) {
    Array.prototype.slice.call(root.querySelectorAll('img')).forEach(function (img) {
      if (img.closest('.vg-media, .vg-hero, .vg-definition-image, .vg-origin-image, .vg-science-image, .vg-responsible-image, .vg-product-image, .vg-wide-image')) {
        return;
      }

      var parent = img.parentElement;
      if (parent && parent.tagName === 'P' && parent.children.length === 1) {
        parent.classList.add('vg-media');
        return;
      }

      var frame = document.createElement('div');
      frame.className = 'vg-media';
      img.parentNode.insertBefore(frame, img);
      frame.appendChild(img);
    });
  }

  function isCustomStructured(root) {
    return !!(
      root.querySelector(
        '.vg-kicker, .vg-hero, .vg-definition, .vg-timeline, .vg-howto, .vg-product, .vg-final, article.vg-article'
      ) || root.classList.contains('vg-article--custom')
    );
  }

  function enhance(root) {
    if (!root || root.classList.contains('vg-article--enhanced')) return;
    if (isCustomStructured(root)) {
      root.classList.add('vg-article--custom');
      root.classList.remove('vg-article--auto');
      return;
    }
    wrapIntro(root);
    wrapBenefits(root);
    wrapCtaAndAbout(root);
    wrapImages(root);
    root.classList.add('vg-article--enhanced');
  }

  function init() {
    document.querySelectorAll('.article__content.vg-article--auto').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
